import { styled } from '@mui/system'
import { IconButton as Btn } from '@mui/material'
import { SELECTED_COLOR } from '../../constants'

export const IconButtonWrapper = styled(Btn)(`
  border-radius: 0;
  button { background: transparent !important;}
  &:hover {
    background: transparent !important;
    svg path { fill: ${SELECTED_COLOR}  }
  }
`)
